export type TargetType = 'search' | 'all'
export type EncodingType = 'UTF-8' | 'Windows-31J'

type Order = 'asc' | 'desc'
type SortColumn = 'color' | 'alert_start' | 'alert_type_name' | 'base_date' | 'staff_code' | 'employee_name'

export interface CsvDownloadSearchParams {
  sort_order: Order
  sort_column: SortColumn
  alert_start_start_on: string
  alert_start_end_on: string
  base_date_start_on?: string
  base_date_end_on?: string
  alert_status: 'in_progress' | 'completed' | null
  search_value: string
  alert_type_ids: number[]
}

export const normalizeBaseDate = (query: CsvDownloadSearchParams | null) => ({
  ...query,
  base_date_start_on: query?.base_date_start_on || undefined,
  base_date_end_on: query?.base_date_end_on || undefined,
})
